"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _AutocompleteDebounce = _interopRequireDefault(require("./AutocompleteDebounce"));

var _ListItem = require("../../ListItem");

var _excluded = ["form", "field", "fetchOptions", "user"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CityTagAutocomplete = function CityTagAutocomplete(_ref) {
  var form = _ref.form,
      field = _ref.field,
      fetchOptions = _ref.fetchOptions,
      user = _ref.user,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_AutocompleteDebounce["default"], _extends({
    fetchOptions: fetchOptions,
    getOptionLabel: getCityTagOptionLabel,
    getOptionSelected: getCityTagOptionSelected,
    renderOption: renderCityTagOption,
    field: field,
    form: form
  }, props));
};

var _default = CityTagAutocomplete; // Tags

exports["default"] = _default;

var getCityTagOptionSelected = function getCityTagOptionSelected(option, value) {
  return cityTagSelected(option) === cityTagSelected(value);
};

var getCityTagOptionLabel = function getCityTagOptionLabel(option) {
  return option === "" ? "" : cityTagSelected(option);
};

var renderCityTagOption = function renderCityTagOption(option, state) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/_react["default"].createElement(_ListItem.ItemCityTag, {
    id: option.id,
    title: option.title
  }));
};

var cityTagSelected = function cityTagSelected(cityTag) {
  var temp = [];
  cityTag && cityTag.title && temp.push(cityTag.title);
  cityTag && cityTag.id && temp.push("[".concat(cityTag.id, "]"));
  return temp.join(" ");
};

CityTagAutocomplete.propTypes = {
  /**
   * The label content.
   */
  label: _propTypes["default"].string,
  fetchOptions: _propTypes["default"].func.isRequired,

  /**
   * Formik field
   */
  field: _propTypes["default"].shape({
    name: _propTypes["default"].string.isRequired,
    value: _propTypes["default"].any
  }),

  /**
   * Formik form
   */
  form: _propTypes["default"].shape({
    touched: _propTypes["default"].object,
    errors: _propTypes["default"].object,
    setFieldValue: _propTypes["default"].func.isRequired
  }).isRequired
};